<template>
  <v-container fluid>
    <v-layout>
      <v-row>
        <v-col cols="12" md="8" class="pt-0">
          <v-card>
            <v-img :src="getBackImageFinalizacion"> </v-img>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="pt-0 d-flex flex-column align-center justify-center"
        >
          <p class="text-h5 text-center">Lo lograste!</p>
          <p class="text-body-2 text-center text--secondary">
            Tus respuestas están siendo procesadas, el resultado será mostrado
            en la página de tu perfil
          </p>
          <v-btn color="indigo" dark :to="{ path: '/usuario/perfil' }"
            ><v-icon left>mdi-open-in-new</v-icon>Ver Resultados en el
            Perfil</v-btn
          >
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    getBackImageFinalizacion() {
      return require("@/assets/finalizado.jpg");
    }
  }
};
</script>

<style>
</style>
